export class ExportLeap {
	static readonly type = '[accounting] export leap';
}

export class ExportSoluno {
	static readonly type = '[accounting] export soluno';
}

export class ExportCosmolex {
	static readonly type = '[accounting] export cosmolex';
}

export class ExportGhostPractice {
	static readonly type = '[accounting] export ghostpractice';
}

export class PrintSoluno {
	static readonly type = '[accounting] print soluno';
}

export class PrintCosmolex {
	static readonly type = '[accounting] print cosmolex';
}

export class PrintGhostPractice {
	static readonly type = '[accounting] print ghostpractice';
}
